import { render, staticRenderFns } from "./CreateCustomerForm.vue?vue&type=template&id=7d77420f&scoped=true&"
import script from "./CreateCustomerForm.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d77420f",
  null
  
)

export default component.exports